import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE = {
  width: 12,
  height: 12,
  background: '#94a3b8',
  border: '2px solid white',
} as const

const HANDLE_STYLE_ACTIVE = {
  ...HANDLE_STYLE,
  background: '#3b82f6',
} as const

// v10.0 新增：身份模拟专用节点（PersonaAgent）
export const PersonaAgentNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds, sceneConfigs } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)
  
  // v10.3: 从 Context 获取场景配置（动态加载自 Identity Engine API）
  const sceneConfig = sceneConfigs.find((s: any) => s.scene_tag === data.scene_id)
  const sceneInfo = sceneConfig 
    ? { icon: sceneConfig.icon, label: sceneConfig.name }
    : { icon: '🎭', label: data.scene_id || '未配置' }
  
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-violet-50 border-2 min-w-[180px] transition-all duration-300 ${
      isActive 
        ? 'border-violet-500 ring-4 ring-violet-400/50 shadow-xl scale-105 animate-pulse' 
        : selected 
          ? 'border-violet-500 ring-2 ring-violet-500/20 shadow-xl' 
          : isVisited 
            ? 'border-violet-300 ring-2 ring-violet-200/50' 
            : 'border-violet-200'
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#8b5cf6' } : { ...HANDLE_STYLE, background: '#8b5cf6' }}
      />
      
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-md transition-colors duration-300 ${isActive ? 'bg-violet-500' : 'bg-violet-100'}`}>
          <span className="text-lg">{sceneInfo.icon}</span>
        </div>
        <div>
          <div className="font-medium text-sm text-violet-900">{data.label}</div>
          <div className="text-xs text-violet-600 flex items-center gap-1">
            <span>🎭</span>
            <span>{sceneInfo.label}</span>
          </div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#8b5cf6' } : { ...HANDLE_STYLE, background: '#8b5cf6' }}
      />
    </div>
  )
})

PersonaAgentNode.displayName = 'PersonaAgentNode'